import { useSelector } from "react-redux";

// All portal pages need a candidateId. We pull from signin slice; fall back to demo userId 200.
export const useCandidateId = () => {
  const userId = useSelector((s) => s.signinSliceReducer?.userId);
  return userId || 200;
};

export const PageHeader = ({ title, subtitle, action }) => (
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12, marginBottom: 16 }}>
    <div>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: "#0F172A", margin: 0 }}>{title}</h1>
      {subtitle && <p style={{ fontSize: 13, color: "#64748B", margin: "4px 0 0" }}>{subtitle}</p>}
    </div>
    {action}
  </div>
);

export const Card = ({ children, style, ...rest }) => (
  <div style={{ background: "white", border: "1px solid #E2E8F0", borderRadius: 12, padding: 16, ...style }} {...rest}>
    {children}
  </div>
);

export const Stat = ({ value, label, color = "#0F172A" }) => (
  <div style={{ flex: 1, textAlign: "center", padding: "12px 8px" }}>
    <div style={{ fontSize: 24, fontWeight: 700, color }}>{value}</div>
    <div style={{ fontSize: 11, color: "#64748B", marginTop: 2 }}>{label}</div>
  </div>
);

export const Empty = ({ message }) => (
  <div style={{ padding: 24, textAlign: "center", color: "#94A3B8", fontSize: 13 }}>{message}</div>
);

export const Pill = ({ children, color = "#7B5AC4", bg = "#EEF2FF" }) => (
  <span style={{ fontSize: 10, padding: "2px 8px", borderRadius: 100, color, background: bg, fontWeight: 600 }}>
    {children}
  </span>
);
